export const PopupWidth = {
  FILL: '95vw',
  LARGE: '960px',
  MEDIUM: '560px',
  SMALL: '464px',
};

export type PopupWidth = (typeof PopupWidth)[keyof typeof PopupWidth];
